const ACCENT = '#2D5F4F';

export const SuccessCheckBadge = ({ size = 48 }: { size?: number }) => {
	return (
		<div
			className="flex items-center justify-center"
			style={{
				width: size,
				height: size,
				background: 'rgba(45, 95, 79, 0.10)',
				borderRadius: '50%',
			}}
		>
			<svg
				viewBox="0 0 48 48"
				width={size}
				height={size}
				style={{ display: 'block' }}
			>
				<path
					d="M15 25 L22 32 L34 19"
					fill="none"
					stroke={ACCENT}
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};
